import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";

import { dropdownAtomFamily, IDropdownItemShifts } from "@ryde/shared";

import {
  getSelectedPassengerUnitIds,
  hasPassengersFromUnaffiliatedUnits,
} from "../helpers";

export const useUnaffiliatedUnitsWarning = ({
  passengerItems,
  selectedPassengerIds,
  shiftFieldName,
}: {
  passengerItems: { value?: number | string; unitId?: number | null }[];
  selectedPassengerIds?: number[];
  shiftFieldName: string;
}) => {
  const { watch } = useFormContext();
  const shiftDropdownItems: IDropdownItemShifts[] = useRecoilValue(
    dropdownAtomFamily("shift"),
  );
  const shiftId = watch(shiftFieldName);

  const hasUnaffiliatedUnits = useMemo(() => {
    const selectedShift = shiftDropdownItems.find(
      item => item.value === shiftId,
    );

    return hasPassengersFromUnaffiliatedUnits({
      shiftUnitIds: selectedShift?.unitIds,
      passengerUnitIds: getSelectedPassengerUnitIds({
        passengerItems,
        selectedPassengerIds,
      }),
    });
  }, [shiftDropdownItems, shiftId, passengerItems, selectedPassengerIds]);

  return {
    hasUnaffiliatedUnits,
  };
};
